(() => {
  const initialize = () => {
    const gate = document.getElementById('patron-age-gate');
    if (!gate || gate.dataset.initialized === 'true') return;
    gate.dataset.initialized = 'true';
    const root = document.documentElement;
    if (!root.classList.contains('patron-age-pending')) return;
    const affirmative = gate.querySelector('#patron-age-yes');
    if (!affirmative) return;
    const exitUrl = gate.dataset.exitUrl || 'https://www.google.com/';
    gate.addEventListener('cancel', (event) => {
      event.preventDefault();
      window.location.replace(exitUrl);
    });
    affirmative.addEventListener('click', () => {
      const days = Math.min(90, Math.max(1, Number.parseInt(gate.dataset.cookieDays, 10) || 30));
      document.cookie = 'patron_age_confirmed_v1=1; Max-Age=' + (days * 86400) + '; Path=/; SameSite=Lax; Secure';
      root.classList.remove('patron-age-pending');
      if (gate.open) gate.close();
    }, { once: true });
    if (typeof gate.showModal === 'function') {
      try { gate.showModal(); } catch { gate.setAttribute('open', ''); }
    } else gate.setAttribute('open', '');
    affirmative.focus();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
